import { Link } from 'react-router-dom';
import { getAllArticles } from '../data/articles';

function ArticleList() {
  const articles = getAllArticles();

  return (
    <div className="min-h-screen bg-cover bg-center bg-no-repeat bg-scroll" style={{backgroundImage: "url('/background.png')"}}>
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12 mt-4 sm:mt-8 px-2">
          <Link to="/" className="inline-block mb-4 sm:mb-6">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-orange-500 hover:text-orange-600 transition-colors">
              Fatak App
            </h1>
          </Link>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4 px-2">
            News & Updates
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto px-4">
            Stay informed about the latest updates, features, and news from Fatak App
          </p>
        </div>

        {/* Articles Grid */}
        <div className="max-w-5xl mx-auto space-y-6 sm:space-y-8 mb-12 sm:mb-16 px-2">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/news/${article.slug}`}
              className="block bg-white/95 backdrop-blur-sm rounded-xl sm:rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 overflow-hidden group"
            >
              <div className="p-4 sm:p-6 md:p-8 lg:p-10">
                <div className="flex flex-wrap items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
                  <span className="px-3 sm:px-4 py-1 bg-orange-500 text-white text-xs sm:text-sm font-bold rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs sm:text-sm text-gray-500 hidden sm:inline">{article.location}</span>
                  <span className="text-xs sm:text-sm text-gray-500 hidden sm:inline">•</span>
                  <span className="text-xs sm:text-sm text-gray-500">
                    {new Date(article.date).toLocaleDateString('en-US', { 
                      year: 'numeric', 
                      month: 'short', 
                      day: 'numeric' 
                    })}
                  </span>
                  <span className="text-xs sm:text-sm text-gray-500 sm:hidden w-full mt-1">{article.location}</span>
                </div>
                
                <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 group-hover:text-orange-600 transition-colors leading-tight">
                  {article.title}
                </h3>
                
                <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed mb-4">
                  {article.excerpt}
                </p>
                
                <div className="flex items-center text-orange-600 font-semibold text-sm sm:text-base group-hover:gap-2 transition-all">
                  Read More
                  <span className="ml-2 group-hover:translate-x-1 transition-transform">→</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Back to Home */}
        <div className="text-center mb-8 px-4">
          <Link
            to="/"
            className="inline-block px-5 sm:px-6 py-2.5 sm:py-3 bg-orange-500 text-white text-sm sm:text-base font-semibold rounded-lg hover:bg-orange-600 transition-colors"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ArticleList;

